// extracted by css-extract-rspack-plugin
export default {"gameModalLayer":"kXlJ5i"};